import { WidgetCommon } from './widgetCommon';
import { containerControllers } from './widgetCommon.container';
import { WIDGET } from '../../constants/WIDGET';

containerControllers.bind(WIDGET).to(WidgetCommon).inSingletonScope();

export { containerControllers as container };